export default __webpack_public_path__ + "fc0d0f8b4b3cd2ce2c717c114adbaec4.png";